import { render, staticRenderFns } from "./accountmanagement.vue?vue&type=template&id=25f9da7e&scoped=true&"
import script from "./accountmanagement.vue?vue&type=script&lang=js&"
export * from "./accountmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f9da7e",
  null
  
)

export default component.exports